import type { IExtractRouteParamMap, IRouteTranslation } from "../../types";
import { createBreadcrumbObject, createPaths, rebase } from "../../utils";

// Base route constant
const baseRoute = `/research-proposal-management`;

// * Route configuration object for researchProposal-related paths.
// ! This object is `readonly` to ensure route parameters are extracted properly.
export const researchProposalRoutesObj = {
  list: baseRoute,
  create: `${baseRoute}/create`,
  view: `${baseRoute}/view/:researchId`,
  edit: `${baseRoute}/edit/:researchId`,
} as const;

// ! these are breadcrumbs translation not page title
const researchProposalRouteTranslation: IRouteTranslation<
  typeof researchProposalRoutesObj
> = {
  list: "researchProposalManagement",
  create: "addResearchProposal",
  edit: "editResearchProposal",
  view: "viewResearchProposal",
};

// * Extracts the route parameters for the researchProposal route configuration.
export type IResearchProposalRouteParams = IExtractRouteParamMap<
  typeof researchProposalRoutesObj
>;

// * Path functions for the researchProposal routes.
export const researchProposalPath = createPaths<
  typeof researchProposalRoutesObj,
  IResearchProposalRouteParams
>(researchProposalRoutesObj);

// * Breadcrumbs {translation and route} for the faculty routes
export const researchProposalBreadcrumbs = createBreadcrumbObject<
  typeof researchProposalRoutesObj
>(researchProposalRoutesObj, researchProposalRouteTranslation);
rebase(researchProposalBreadcrumbs, "list");
